export default "__VITE_ASSET__CWL3ipev__"